/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');

    app.directive('switcher', ['$timeout', '$sce', function ($timeout, $sce) {
        var uid = 0;
        return {
            restrict: 'EA',
            require: 'ngModel',
            scope: {
                ngModel: '=',
                valueTrue: '=?',
                valueFalse: '=?',
                labelTrue: '@?',
                labelFalse: '@?',
                change: '=?ngChange',
                isDisabled: '=?ngDisabled',
            },
            template: function (element, attributes) {
                var name = attributes.name || 'switcher' + (++uid);
                return '<div class="switcher" ng-class="{ active: isActive, disabled: isDisabled }">' +
                        '   <span class="switcher-label false" ng-bind-html="trust(labelFalse)" ng-click="SetSwitch(false)"></span>' +
                        '   <label class="switcher-line">' +
                        '       <input id="' + name + '" name="' + name + '" type="checkbox" ng-model="isActive" ng-disabled="isDisabled" ng-change="onChange()"' + (attributes.required ? ' required="true"' : '') + '>' +
                        '   </label>' +
                        '   <span class="switcher-label true" ng-bind-html="trust(labelTrue)" ng-click="SetSwitch(true)"></span>' +
                        '</div>';
            },
            link: function (scope, element, attributes, model) {
                var input = element[0].querySelector('input');
                var properties = {
                    valueTrue: true,
                    valueFalse: false,
                    isDisabled: false,
                };
                var attrs = {
                    labelTrue: 'On',
                    labelFalse: 'Off',
                };
                angular.forEach(properties, function (value, key) {
                    if (!angular.isDefined(scope[key])) {
                        scope[key] = value;
                    }
                });
                angular.forEach(attrs, function (value, key) {
                    if (!angular.isDefined(scope[key])) {
                        attributes[key] = value;
                    }
                });
                scope.trust = function (value) {
                    return $sce.trustAsHtml(value);
                };
                scope.SetSwitch = function (value) {
                    // console.log('switcher.set', value);
                    if (scope.isDisabled || input.checked === value) {
                        return;
                    }
                    scope.isActive = input.checked = value;
                    scope.onChange();
                };
                scope.onChange = function () {
                    console.log('switcher.onChange', input.checked);
                    var oldvalue = model.$modelValue;
                    var value = input.checked ? scope.valueTrue : scope.valueFalse; // scope.isActive

                    console.log(scope);

                    model.$setViewValue(value);
                    model.$render();
                    console.log('model', model, model.$modelValue, value);
                    if (angular.isFunction(scope.change)) {
                        $timeout(function () {
                            scope.change(value, oldvalue);
                        });
                    }
                };
                scope.$watch('ngModel', function (newValue) {
                    scope.isActive = (newValue === scope.valueTrue);
                    if (input.checked !== scope.isActive) {
                        input.checked = scope.isActive;
                    }
                });
            },
        };
    }]);
}());